var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"app_header"},[_c('a',{attrs:{"href":_vm.homeUrl}},[_c('img',{attrs:{"src":require("../assets/logo.svg")}})]),_vm._v(" "),_c('div',{staticClass:"text_part"},[_vm._v(_vm._s(_vm.app_name)+" Application")])])
}
var staticRenderFns = []

export { render, staticRenderFns }